var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcCloseRound16 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ic-close-round-16_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#e34646",
  fillRule: "evenodd",
  d: "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m2.16-11.696a1.033 1.033 0 0 1 1.463 0 1.04 1.04 0 0 1 0 1.468L9.438 7.963l2.259 2.265a1.04 1.04 0 0 1 0 1.468 1.033 1.033 0 0 1-1.464 0L7.974 9.431l-2.207 2.213a1.033 1.033 0 0 1-1.464 0 1.04 1.04 0 0 1 0-1.468L6.51 7.963 4.377 5.824a1.04 1.04 0 0 1 0-1.468 1.033 1.033 0 0 1 1.464 0l2.133 2.14z",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "ic-close-round-16_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})))));
export default SvgIcCloseRound16;